import { render, staticRenderFns } from "./addTags.vue?vue&type=template&id=44991632&scoped=true&"
import script from "./addTags.vue?vue&type=script&lang=js&"
export * from "./addTags.vue?vue&type=script&lang=js&"
import style0 from "./addTags.vue?vue&type=style&index=0&id=44991632&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44991632",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/01-qym-hop-newmall-frontend-k8s@3/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44991632')) {
      api.createRecord('44991632', component.options)
    } else {
      api.reload('44991632', component.options)
    }
    module.hot.accept("./addTags.vue?vue&type=template&id=44991632&scoped=true&", function () {
      api.rerender('44991632', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mass/components/addTags.vue"
export default component.exports